var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"title":_vm.title,"ok-title":_vm.okTitle,"cancel-title":_vm.cancelTitle},on:{"ok":_vm.confirm,"cancel":_vm.cancel},model:{value:(_vm.visible),callback:function ($$v) {_vm.visible=$$v},expression:"visible"}},[(_vm.visible)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.message)}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }